import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { useSelector } from 'react-redux';
import AddGroupModal from '../Groups/addGroup';
import { addGroup } from '../../../../services/commonapi/commonApi';
import { healthDropdownOptions } from '../../../../utility/data';
import AdminHome from "./adminHome";
import UserHome from "./home";

const Index = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const { role } = useSelector((state) => state.user);
  const toast = useRef(null);
  const accessToken = JSON.parse(localStorage.getItem('access_token'));

  const handleIconClick = () => {
    navigate('/my-view');
  };
  

  const handleAddGroupClick = () => {
    navigate('/view-group');
    setIsModalOpen(true);
  };

  const handleAddLegacyClick = () => {
    navigate('/view-legacy');
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  
  const handleOptionSelect = (option) => {
    const formattedOption = typeof option === 'string'
      ? option.toLowerCase().split(' ').join('-')
      : 'unknown-option';
    navigate(`/view-${formattedOption}-transaction`);
  };
  
  const handleViewWealthClick = () => {
    navigate("/wealth-view");
  };

  const handleSubmit = async ({ name, status, onClose, setError, setLoading }) => {
    if (!name.trim()) {
      setError('Name is required');
      return;
    }

    setLoading(true);
    try {
      const response = await addGroup(name, status, accessToken);
      if (response.data.status === true) {
        toast.current.show({
          className: 'bg-green-300 text-white',
          severity: 'success',
          summary: 'Success',
          detail: response.data.message,
          life: 3000,
        });
        onClose();
      } else {
        toast.current.show({
          className: 'bg-yellow-700 text-white',
          severity: 'warn',
          summary: 'Warning',
          detail: response.data.message || 'Failed to add group',
          life: 3000,
        });
      }
    } catch (error) {
      toast.current.show({
        className: 'bg-red-700 text-white',
        severity: 'error',
        summary: 'Error',
        detail: error.message || 'An unexpected error occurred',
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='flex justify-center items-center h-full'>
      <Toast ref={toast} />
      {role === 'user' && (
        <UserHome handleOptionSelect={handleOptionSelect} healthDropdownOptions={healthDropdownOptions} handleAddGroupClick={handleAddGroupClick} handleIconClick={handleIconClick} handleAddLegacyClick={handleAddLegacyClick} handleViewWealthClick={handleViewWealthClick}/>
      )}
      {role === 'admin' && (
        <AdminHome />
      )}

      {isModalOpen && (
        <AddGroupModal
          onClose={handleModalClose}
          handleSubmit={handleSubmit}
        />
      )}
    </div>
  );
};

export default Index;
